const RATES_LOAD = `RATES_LOAD`;
const FAILURE = `FAILURE`;
const BASE_CURRENCY_SET = `BASE_CURRENCY_SET`;
const FAVORITE_TOGGLE = `FAVORITE_TOGGLE`;

export default {
  RATES_LOAD,
  FAILURE,
  BASE_CURRENCY_SET,
  FAVORITE_TOGGLE
}
